import { createIdleWhistleFrames, createWhistleNoteFrames } from "../../core/personality-keyframes.js";

export const meta = Object.freeze({
  id: "idle-whistle",
  label: "Idle: Pfeifen",
  duration: 6800,
  description: "Orbi holt sichtbar Luft und pfeift zweimal einen längeren Strom aus kleinen Noten.",
  tags: ["body", "expression", "idle", "ambient", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  if (!scene?.whistleNotes || scene.whistleNotes.length !== 5) {
    throw new Error("Die Pfeif-Sequenz benötigt die Musiknoten der Stage.");
  }
  const frames = createIdleWhistleFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.mouthWhistle, frames.mouth, options),
    animate(elements.mouthWhistleClosed, frames.mouthClosed, options),
    ...scene.whistleNotes.map((note, index) => animate(note, createWhistleNoteFrames(index), options)),
  ];
  await Promise.allSettled(animations.map(({ finished }) => finished));
}
